import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {ProAreaVariavel} from "../types/ProAreaVariavel.type";
import {ProAnalise} from "../types/ProAnalise.type";
import {ProAtributo} from "../types/ProAtributo.type";

@Injectable({
  providedIn: 'root'
})
export class ProanaliseService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAnalises() {
    return this.httpClient.get<ProAnalise[]>(`${this.configService.getApiUrlRoot()}/proanalise/analises`);
  }

  getAnalise(id: number) {
    return this.httpClient.get<ProAnalise>(`${this.configService.getApiUrlRoot()}/proanalise/analises/${id}`);
  }
}
